import React, { useRef } from 'react';
import { Button } from '@mui/material';
import { PhotoCamera } from '@mui/icons-material';

const ImageUpload = ({ onChange, buttonText = 'Subir Foto' }) => {
  const fileInputRef = useRef(null);
  
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };
  
  return (
    <>
      <input
        accept="image/*"
        type="file"
        onChange={onChange}
        ref={fileInputRef}
        style={{ display: 'none' }}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleButtonClick}
        startIcon={<PhotoCamera />}
      >
        {buttonText}
      </Button>
    </>
  );
};

export default ImageUpload;